import FileUploadDocument from "components/FileUpload/FileUploadDocument";
import React from "react";
import CustomeSelectNew from "components/UpdateUi/CustomeSelect.js";
import { purposeOfLoanNewList } from "assets/properties/properties";
import { Grid } from "@material-ui/core";
import { parseAndSetFlag } from "utils/Utils";

const DocumentLinks = ({
  title = "Documents",
  kycDocumentType,
  kycDocumentTypes = [],
  onKycDocumentChange,
  kycPreviewImage,
  kycUploadRef,
  onKycUpload,
  documentCasesNames = {},
  documentImages = [],
  documentRefs = [],
  fileUploadComponent,
  brandTheme,
  onDeleteUpload,
  applicantDetails,
  ornamentDetail,
  occupationProofDocName,
  setOccupationProofDocName,
  classes,
  featureFlags,
}) => {
  return (
    <>
      <div style={{ paddingLeft: "9%", display: "flex", gap: 150 }}>
        
        {/* Face Identity */}
        <div>
          <p style={{
          fontSize: 22,
          fontWeight: "bold",
          textAlign: "left",
          paddingLeft: "9%",
          marginBottom: 0,
        }}>Face Identity</p>
        {parseAndSetFlag(featureFlags?.enabledAadharMaskedPhoto) &&
          <div
              style={{
                width: '100%',
                borderRadius: 8,
                padding: "0px 10px 10px 10px",
                marginTop: 20,
              }}>
          <CustomeSelectNew
            label="Document Type*"
            value={kycDocumentType}
            setState={onKycDocumentChange}
            data={kycDocumentTypes}
            type="displayName"
            id="document_type"
          />
          </div>
        }
          <div
            style={{
              width: '20%',
              minHeight: 200,
              borderRadius: 8,
              padding: "0px 10px 10px 10px",
            }}
          >
            <FileUploadDocument
              addButtonProps={{ color: brandTheme.buttonColor }}
              changeButtonProps={{ color: brandTheme.buttonColor }}
              removeButtonProps={{ color: brandTheme.button2Color }}
              supportedMimeType={[
                "image/jpeg",
                "image/bmp",
                "image/png",
                "image/tiff",
                "application/pdf",
              ]}
              sendFile={(file) => onKycUpload(file, documentCasesNames?.kyc)}
              removeFile={() => onDeleteUpload(documentCasesNames?.kyc)}
              previewImage={kycPreviewImage?.face}
              ref={kycUploadRef?.face}
            />
          </div>
        </div>
      </div>
      <p
        style={{
          fontSize: 22,
          fontWeight: "bold",
          textAlign: "left",
          paddingLeft: "9%",
          marginBottom: 0,
        }}
      >
        {title}
      </p>
      <div
        style={{
          paddingLeft: "9%",
          display: "flex",
          flexWrap: "wrap",
        }}
      >
        {[0, 1, 2, 3, 4].map((i) => (
          <div
            key={i}
            style={{
              width: 140,
              minHeight: 330,
              borderRadius: 8,
              padding: '0px 10px 10px 10px',
              marginRight: 40,
            }}
          >
            {fileUploadComponent(
              documentCasesNames[`case${i + 1}`],
              documentImages[i],
              documentRefs[i]
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default DocumentLinks;
